export enum SmartDetectionTypes {
  AroundTrip = 'LOCATION',
  List = 'LIST',
  Map = 'Map'
}
